import { App as SrvgApp, CustomerIntegrationController, InactivityController, Server, MaintenanceEvent, JsonFeed } from "@gaming/srvg-classes-core";
import { TimelineController } from "../Controller/TimelineController";
import { OddsfeedController } from "../Controller/OddsfeedController";
import { MatchIdsFeedController } from "../Controller/MatchIdsFeedController";

/**
 * <strong>VBL Virtual Basketball league.</strong>
 *
 * This is the application class for VBL.
 */
export class App extends SrvgApp {

    maintenanceWorker: Worker;
    timelineController: TimelineController;
    oddsfeedController: OddsfeedController;
    matchIdsFeedController: MatchIdsFeedController;
    customerIntegration: CustomerIntegrationController;
    inactivityController: InactivityController;
    server: Server;

    constructor( options ) {
        options = options || {};
        super( options );

        this.timelineController     = new TimelineController( { url: srvg.url.timeline } );


        /* Maintenance Handling */
        this.addSubscriberForEvent(srvg.maintenance, MaintenanceEvent);
        var that = this;
        this.maintenanceWorker = new Worker(srvg.url.maintenance_worker);
        this.maintenanceWorker.postMessage({action: 'set_options', options: {
                url: srvg.maintenanceCheck.url,
                frequency: srvg.maintenanceCheck.pollFrequency
            }});
        this.maintenanceWorker.postMessage({action: 'start_polling'});
        this.maintenanceWorker.addEventListener('message', function(e){
            switch( e.data.message ) {
                case 'maintenance':
                    that.triggerEvent(new MaintenanceEvent({maintenance: true}));
                    break;
            }
        });



        this.oddsfeedController     = new OddsfeedController({
            feed: new JsonFeed( { url: srvg.url.oddsfeed } ),
            maxSize: 60
        });
        this.matchIdsFeedController = new MatchIdsFeedController( {
            feed: new JsonFeed( { url: srvg.url.matchidsfeed } ),
            maxSize: 60
        } );
        if( options.customerIntegration ) {
            this.customerIntegration = new CustomerIntegrationController({});
        }
        this.server = new Server( {} );

        if( options.inactivityController ) {
            this.inactivityController = new InactivityController( { timeout: 2*60*60*1000 } );
        }
    }
}